<template>
	<v-dialog
		:value="dialog"
		fullscreen
		hide-overlay
		transition="dialog-bottom-transition"
	>
		<v-card>
			<v-toolbar
				dark
				color="primary"
			>
				<v-btn
					icon
					dark
					@click.native="hideDialog()"
				>
					<v-icon>close</v-icon>
				</v-btn>
				<v-toolbar-title>
					<h1 class="text-xs-center">{{ dialogTitle }}</h1>
				</v-toolbar-title>
				<slot name="toolbar"/>
			</v-toolbar>
			<div class="dialog-content">
				<slot name="dialog-content"/>
			</div>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	props: {
		dialog: { default: false, type: Boolean },
		dialogTitle: { default: '', type: String },
		handleOverflow: { default: true, type: Boolean },
	},
	watch: {
		dialog(val) {
			if (!this.handleOverflow) {
				return;
			}
			if (val) {
				document.documentElement.style.overflowY = 'hidden';
				return;
			}
			document.documentElement.style.overflowY = 'scroll';
		},
	},
	methods: {
		hideDialog() {
			this.$emit('close-dialog');
		},
	},
};
</script>

<style lang="scss" scoped>
.dialog-content {
	height: calc(100vh - 64px);
	overflow: auto;
}
</style>
